/**
 * Strip a phone string down to digits only.
 * Returns the raw string if it contains no digits.
 */
export function stripToDigits(raw: string | null | undefined): string {
  if (!raw) return '';
  const digits = raw.replace(/\D/g, '');
  return digits;
}

/**
 * Format a phone number string for display.
 * Handles 10-digit and 11-digit (1 + 10) US numbers.
 * Returns the raw value unchanged if it can't be parsed as a US number.
 */
export function formatPhoneNumber(raw: string | null | undefined): string {
  if (!raw) return '';
  const digits = stripToDigits(raw);
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  if (digits.length === 11 && digits[0] === '1') {
    return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  return raw.trim();
}

/**
 * Format-on-blur handler for phone inputs.
 * Formats the current value to (XXX) XXX-XXXX if possible,
 * otherwise leaves it as-is.
 */
export function formatPhoneOnBlur(value: string): string {
  if (!value) return value;
  const formatted = formatPhoneNumber(value);
  return formatted;
}

/**
 * Normalize a phone number to 10 digits for comparison.
 * Strips country code 1 if present. Returns empty string if not a valid US number.
 */
export function normalizePhoneForComparison(raw: string | null | undefined): string {
  const digits = stripToDigits(raw);
  if (digits.length === 10) return digits;
  if (digits.length === 11 && digits[0] === '1') return digits.slice(1);
  return '';
}
